import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import AutoSizer, { Size } from 'react-virtualized-auto-sizer';
import isEqual from 'lodash.isequal';
import { push } from 'connected-react-router';

import { AppState } from 'services/types';
import {
    VirtualizedTableColumnKey,
    VirtualizedTableColumnWidth,
    VirtualizedTableColumns,
    VirtualizedTableItem
} from 'services/virtualizedTable/types';

import { setColumnWidth } from 'services/columnWidths/actions';
// import { requestDeleteSpraySubmission as requestDeleteSpraySubmissionAction } from 'services/spraySubmission/actions';
import VirtualizedTable from 'components/VirtualizedTable';

import { requestDeleteSpraySubmissions as requestDeleteSpraySubmissionsAction } from 'services/spraySubmissions/actions';
import {
    selectSubmissionsTableColumns,
    makeSelectSubmissionItems,
    selectIsWritable
} from './selectors';

interface OwnProps {
    tableId: string;
}

interface ConnectedProps {
    items: VirtualizedTableItem[];
    columns: VirtualizedTableColumns;
    isWritable: boolean;
}

interface DispatchProps {
    setColumnWidth: typeof setColumnWidth;
    push: Function;
    requestDeleteSpraySubmissions: typeof requestDeleteSpraySubmissionsAction;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class SubmissionsVirtualizedTableComponent extends React.Component<Props> {
    shouldComponentUpdate(nextProps: Props): boolean {
        return !isEqual(this.props, nextProps);
    }

    handleColumnResized = (
        columnKey: VirtualizedTableColumnKey,
        columnWidth: VirtualizedTableColumnWidth
    ): void => {
        const { tableId, ...props } = this.props;
        props.setColumnWidth(tableId, columnKey, columnWidth);
    };

    handleDelete = (items: VirtualizedTableItem[]): void => {
        const { requestDeleteSpraySubmissions } = this.props;

        if (items[0] && items[0].id) {
            requestDeleteSpraySubmissions(items[0].id);
        }
    };

    renderVirtualizedTable = ({ height, width }: Size): React.ReactElement => {
        const { tableId, items, columns, isWritable, ...props } = this.props;

        return (
            <VirtualizedTable
                id={tableId}
                label="Submission"
                labelPlural="Submissions"
                height={height}
                width={width}
                columns={columns}
                items={items}
                enableDeleting={isWritable}
                selectable={isWritable}
                onDelete={this.handleDelete}
                onColumnResized={this.handleColumnResized}
                onExpand={(id): void =>
                    props.push(`/organization/spray/submissions/${id}`)
                }
            />
        );
    };

    render(): React.ReactElement {
        return (
            <AutoSizer>
                {(size: Size): React.ReactElement =>
                    this.renderVirtualizedTable(size)
                }
            </AutoSizer>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    items: makeSelectSubmissionItems(),
    columns: selectSubmissionsTableColumns,
    isWritable: selectIsWritable
});

export default connect(mapStateToProps, {
    push,
    setColumnWidth,
    requestDeleteSpraySubmissions: requestDeleteSpraySubmissionsAction
})(SubmissionsVirtualizedTableComponent);
